import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    InputSignal,
    signal,
    WritableSignal,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { CompositionAttributeFilterButtonComponent } from '@connect-services/client/pages/filter/layer/create-layer-filter/composition-attribute-filter-form/composition-attribute-filter-button/composition-attribute-filter-button.component';
import { MapFilterCompositionService } from '@connect-services/client/services/map-filter-composition.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

const compositionPlaceholders: Record<number, string> = {
    1: 'Ex : 1 AND 2',
    2: 'Ex : (1 AND 2) OR 3',
    3: 'Ex : (1 AND 2) OR (3 AND 4)',
    4: 'Ex : ((1 AND 2) OR (3 AND 4)) AND 5',
    5: 'Ex : ((1 AND 2) OR (3 AND 4)) AND (5 OR 6)',
    6: 'Ex : (((1 AND 2) OR (3 AND 4)) AND (5 OR 6)) OR 7',
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CompositionAttributeFilterButtonComponent, RessourcesModule],
    selector: 'app-composition-attribute-filter-form',
    styleUrl: './composition-attribute-filter-form.component.scss',
    templateUrl: './composition-attribute-filter-form.component.html',
})
export class CompositionAttributeFilterFormComponent {
    public readonly compositionInputPlaceholder: WritableSignal<string> = signal('');
    public readonly filterAttributeCount: InputSignal<number> = input.required<number>();
    public readonly isEditDisabled: InputSignal<boolean> = input.required<boolean>();
    public readonly panelWidthTwoThird: InputSignal<boolean> = input.required<boolean>();

    protected readonly mapFilterCompositionService = inject(MapFilterCompositionService);
    private readonly translocoService = inject(TranslocoService);

    public constructor() {
        effect(() => {
            this.filterAttributeCount();
            this.mapFilterCompositionService.resetValidation();

            this.compositionInputPlaceholder.set(
                compositionPlaceholders[this.filterAttributeCount() - 1] ||
                    this.translocoService.translate('mapFilter.filterComposition'),
            );
        });
    }
}
